import React from "react";

export default function Logo({ className = "", size = "default" }) {
  const h = size === "lg" ? "h-14" : size === "sm" ? "h-7" : "h-8";
  return (
    <div className={`flex items-center ${className}`}>
      <img
        src="/brand/logo.png"
        alt="TR Premium Cars"
        className={`${h} w-auto object-contain select-none`}
        draggable="false"
      />
    </div>
  );
}
